import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import LTExtra from '../../../../components/LTExtra';
import ExtraPropTypes from '../../../Checkout/CheckoutRoutes/PackageCheckout/proptypes/extras';

const StyledContainer = styled.div`
  padding-bottom: ${({ isMobile }) => (isMobile ? '10px' : '15px')};
`;

const StyledH2 = styled.h2`
  ${({ theme, isMobile }) =>
    theme.typography[isMobile ? 'headline3' : 'headline2']}

  margin-bottom: 12px;
  white-space: pre-line;
`;

const StyledLTExtra = styled(LTExtra)`
  padding-top: 5px;
`;

const ExtraItems = ({ items, isMobile, isHotelOnly }) => {
  const { t } = useTranslation();
  return (
    !isEmpty(items) &&
    !isHotelOnly && (
      <StyledContainer isMobile={isMobile}>
        <StyledH2 isMobile={isMobile}>{t('hotel.extraItems')}</StyledH2>
        {items.map((ltExtra) => (
          <StyledLTExtra key={ltExtra.id} isMobile={isMobile} {...ltExtra} />
        ))}
      </StyledContainer>
    )
  );
};

ExtraItems.defaultProps = {
  items: [],
  isMobile: false,
};

ExtraItems.propTypes = {
  items: ExtraPropTypes.items,
  isMobile: PropTypes.bool,
};

export default ExtraItems;
